/* Phatstix PDP — "Add another balm" interstitial.
   Shown BEFORE the cart drawer when an add leaves exactly ONE balm in the cart, so the
   multi-buy discount + free delivery haven't kicked in. Nudges a second balm.

   Ownership: the main ATC + sticky carry [data-ph-pdp-atc] but NOT [data-ph-quick-add], so
   ph-quick-add ignores them and this file is their sole handler (it adds, then decides drawer
   vs interstitial). Load order is therefore irrelevant — no race, no double-add.

   Permanent dismissal (cookie, ~1yr) happens two ways: the opt-out button, OR a successful
   "add another" — after which it never returns, even if the cart is later emptied. */
(function () {
  if (window.__phAddMoreBound) return;
  window.__phAddMoreBound = true;

  var COOKIE = 'ph_addmore_done';
  var modal = document.querySelector('[data-ph-addmore]');
  // Test mode (customiser toggle): always show + never persist, so the popup can be previewed
  // repeatedly after it's been dismissed.
  var testMode = !!(modal && modal.hasAttribute('data-ph-addmore-test'));
  function hasCookie() { if (testMode) return false; return document.cookie.indexOf(COOKIE + '=1') !== -1; }
  function setCookie() {
    if (testMode) return;
    var d = new Date(); d.setFullYear(d.getFullYear() + 1);
    document.cookie = COOKIE + '=1; path=/; expires=' + d.toUTCString() + '; SameSite=Lax';
  }

  // Open the cart drawer the same way the theme/ph-quick-add does (Alpine modals store, event fallback).
  function openCart() {
    try {
      var m = window.Alpine && Alpine.store && Alpine.store('modals');
      if (m && m.modals && ('cart' in m.modals) && typeof m.open === 'function') {
        if (typeof m.closeAll === 'function') m.closeAll();
        m.open('cart'); return;
      }
    } catch (e) { /* fall through */ }
    document.dispatchEvent(new CustomEvent('theme:open:cart-drawer', { bubbles: true }));
  }
  function refreshCart() { document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true })); }

  function cartAdd(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id * 1, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function (d) { if (d && d.status) throw d; return d; });
  }
  // Total balm units in the cart, by product_type containing "balm" (covers "Balm" + "Lip Balm").
  function balmCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = 0; (c.items || []).forEach(function (it) {
          if ((it.product_type || '').toLowerCase().indexOf('balm') !== -1) n += it.quantity;
        });
        return n;
      });
  }

  var lastTrigger = null;
  function focusables() {
    if (!modal) return [];
    var q = 'button:not([disabled]), [href], select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return [].slice.call(modal.querySelectorAll(q)).filter(function (n) { return n.offsetParent !== null; });
  }
  function onKey(e) {
    if (e.key === 'Escape') { hideModal(); openCart(); return; }    // soft dismiss (no cookie)
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], idx = f.indexOf(document.activeElement);
    if (e.shiftKey) { if (idx <= 0) { e.preventDefault(); last.focus(); } }
    else { if (idx === -1 || document.activeElement === last) { e.preventDefault(); first.focus(); } }
  }
  function showModal() {
    if (!modal) { openCart(); return; }
    modal.hidden = false; modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ph-addmore-open');
    var panel = modal.querySelector('.ph-addmore__panel'); if (panel) panel.focus();
    document.addEventListener('keydown', onKey);
  }
  function hideModal() {
    if (!modal) return;
    modal.hidden = true; modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ph-addmore-open');
    document.removeEventListener('keydown', onKey);
    if (lastTrigger && lastTrigger.isConnected) { try { lastTrigger.focus(); } catch (e) { /* drawer takes focus */ } }
  }

  // Busy label swap on the ATC (ph-quick-add isn't doing it for these buttons any more).
  function setBusy(el, on) {
    if (!el) return;
    if (on) {
      if (el.dataset.phLabel == null) { el.dataset.phLabel = el.innerHTML; el.style.minWidth = el.offsetWidth + 'px'; }
      el.disabled = true; el.setAttribute('aria-busy', 'true'); el.textContent = 'Adding…';
    } else {
      el.disabled = false; el.removeAttribute('aria-busy');
      if (el.dataset.phLabel != null) { el.innerHTML = el.dataset.phLabel; delete el.dataset.phLabel; el.style.minWidth = ''; }
    }
  }

  // ---- the MAIN ATC + sticky ATC are ours alone (no data-ph-quick-add on them) ----
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-ph-pdp-atc]') : null;
    if (!el) return;
    e.preventDefault(); e.stopPropagation();
    var id = el.getAttribute('data-variant-id');
    var qty = parseInt(el.getAttribute('data-quantity') || '1', 10);
    if (!id) return;
    lastTrigger = el;                                  // so the modal can return focus here on close
    setBusy(el, true);
    cartAdd(id, qty)
      .then(function () {
        refreshCart();
        if (hasCookie() || !modal) { setBusy(el, false); openCart(); return; }   // resolved / nothing to offer
        return balmCount().then(function (n) {
          setBusy(el, false);
          if (n === 1) showModal(); else openCart();   // single balm -> nudge; otherwise straight to cart
        });
      })
      .catch(function () {
        setBusy(el, false); refreshCart(); openCart();
        // Same source as ph-quick-add.js: the string is published on <html> from the locale file,
        // so "cart" vs "basket" is a translation change, never a code change.
        var er = document.getElementById('cart-errors');
        if (er) er.textContent = document.documentElement.dataset.phAddFailed || 'Could not add to your basket.';
      });
  }, true);

  if (!modal) return;

  var addBtn = modal.querySelector('[data-ph-addmore-add]');
  var sel = modal.querySelector('[data-ph-addmore-select]');
  var optout = modal.querySelector('[data-ph-addmore-optout]');
  var closers = [].slice.call(modal.querySelectorAll('[data-ph-addmore-close]'));
  var mainPanel = modal.querySelector('[data-ph-addmore-main]');
  var success = modal.querySelector('[data-ph-addmore-success]');

  closers.forEach(function (c) { c.addEventListener('click', function () { hideModal(); openCart(); }); }); // soft
  if (optout) optout.addEventListener('click', function () { setCookie(); hideModal(); openCart(); });      // permanent

  // The chosen second balm swaps the "+1" cutout (read off the hidden <select>'s option data-cut).
  var cut2 = modal.querySelector('[data-ph-addmore-cut2]');
  function syncCut2() {
    if (!sel || !cut2) return;
    var opt = sel.options[sel.selectedIndex];
    var url = opt && opt.getAttribute('data-cut');
    if (url) cut2.src = url;
  }
  if (sel) { sel.addEventListener('change', syncCut2); syncCut2(); }

  // Custom swatch dropdown (a listbox of swatch+name) driving the hidden <select>.
  var dd = modal.querySelector('[data-ph-addmore-dd]');
  var ddlist = modal.querySelector('[data-ph-addmore-ddlist]');
  var ddName = modal.querySelector('[data-ph-addmore-dd-name]');
  var ddSw = modal.querySelector('[data-ph-addmore-dd-sw]');
  if (dd && ddlist && sel) {
    var ddOpts = [].slice.call(ddlist.querySelectorAll('[role="option"]'));
    function ddOpen() {
      ddlist.hidden = false; dd.setAttribute('aria-expanded', 'true');
      var cur = ddlist.querySelector('[aria-selected="true"]') || ddOpts[0];
      ddOpts.forEach(function (o) { o.classList.remove('is-active'); });
      if (cur) { cur.classList.add('is-active'); cur.focus(); }
      document.addEventListener('click', ddOutside, true);
    }
    function ddClose(focusBtn) {
      ddlist.hidden = true; dd.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', ddOutside, true);
      if (focusBtn) dd.focus();
    }
    function ddOutside(e) { if (!dd.contains(e.target) && !ddlist.contains(e.target)) ddClose(false); }
    function ddPick(opt) {
      if (!opt) return;
      sel.value = opt.getAttribute('data-value');
      sel.dispatchEvent(new Event('change', { bubbles: true }));   // -> syncCut2 swaps the +1 cutout
      ddOpts.forEach(function (o) { o.setAttribute('aria-selected', o === opt ? 'true' : 'false'); });
      if (ddName) ddName.textContent = opt.getAttribute('data-name') || (opt.textContent || '').trim();
      var swEl = opt.querySelector('.ph-addmore__ddopt-sw');
      if (ddSw && swEl) ddSw.innerHTML = swEl.innerHTML;
      ddClose(true);
    }
    function ddActiveIdx() { for (var i = 0; i < ddOpts.length; i++) { if (ddOpts[i].classList.contains('is-active')) return i; } return -1; }
    function ddMove(d) {
      var i = ddActiveIdx(); i = (i + d + ddOpts.length) % ddOpts.length;
      ddOpts.forEach(function (o) { o.classList.remove('is-active'); });
      ddOpts[i].classList.add('is-active'); ddOpts[i].focus();
    }
    dd.addEventListener('click', function () { if (ddlist.hidden) ddOpen(); else ddClose(true); });
    dd.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ddOpen(); }
    });
    ddOpts.forEach(function (opt) {
      opt.addEventListener('click', function () { ddPick(opt); });
      opt.addEventListener('keydown', function (e) {
        // list-level keys must not bubble to the dialog's key handler (Esc would close the whole modal)
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); ddPick(opt); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); e.stopPropagation(); ddMove(1); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); e.stopPropagation(); ddMove(-1); }
        else if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); ddClose(true); }
        else if (e.key === 'Tab') { ddClose(false); }
      });
    });
  }

  if (addBtn) addBtn.addEventListener('click', function () {
    var id = sel ? sel.value : addBtn.getAttribute('data-variant-id');
    if (!id) return;
    addBtn.disabled = true; addBtn.setAttribute('aria-busy', 'true');
    cartAdd(id, 1)
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCookie();                              // added a second -> never nudge again
        refreshCart();
        // Only claim "discount unlocked" if Shopify actually discounted the cart (a non-qualifying
        // balm, e.g. one outside the discount's product scope, must not be told it unlocked a deal).
        var discounted = !!cart && ((cart.total_discount && cart.total_discount > 0) || (cart.original_total_price && cart.original_total_price > cart.total_price));
        var txt = modal.querySelector('[data-ph-addmore-success-text]');
        if (mainPanel) mainPanel.hidden = true;
        if (success) { success.hidden = false; success.setAttribute('aria-hidden', 'false'); }
        // Reveal the live region FIRST, then (next tick) write its text + move focus into it — so the
        // status is reliably announced and focus never drops to <body> while the panel is hidden.
        setTimeout(function () {
          if (txt) txt.textContent = discounted ? 'Nice one. Discount unlocked.' : 'Added to your basket.';
          if (success && success.focus) { try { success.focus(); } catch (e) { /* noop */ } }
        }, 30);
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        setTimeout(function () { hideModal(); openCart(); }, reduced ? 700 : 1400);
      })
      .catch(function () {
        addBtn.disabled = false; addBtn.removeAttribute('aria-busy');
        var er = modal.querySelector('[data-ph-addmore-err]'); if (er) er.textContent = 'Could not add that one. Try again?';
      });
  });
})();
